/** Web Speech API helpers for assistant mic → draft (never auto-send). */

export type SpeechLocale = {
  code: string
  label: string
  stt: string
}

export const SPEECH_LOCALES: SpeechLocale[] = [
  { code: 'en', label: 'EN', stt: 'en-US' },
  { code: 'et', label: 'ET', stt: 'et-EE' },
  { code: 'ru', label: 'RU', stt: 'ru-RU' },
  { code: 'nl', label: 'NL', stt: 'nl-NL' },
]

export type SpeechRecognitionLike = {
  lang: string
  interimResults: boolean
  continuous: boolean
  maxAlternatives: number
  start: () => void
  stop: () => void
  abort: () => void
  onstart: ((ev: Event) => void) | null
  onresult: ((ev: SpeechRecognitionResultEventLike) => void) | null
  onerror: ((ev: { error: string }) => void) | null
  onend: (() => void) | null
}

export type SpeechRecognitionResultEventLike = {
  resultIndex: number
  results: ArrayLike<{
    isFinal: boolean
    0: { transcript: string }
  }>
}

type SpeechWindow = Window & {
  SpeechRecognition?: new () => SpeechRecognitionLike
  webkitSpeechRecognition?: new () => SpeechRecognitionLike
}

export function getSpeechRecognitionCtor(): (new () => SpeechRecognitionLike) | null {
  if (typeof window === 'undefined') return null
  const w = window as SpeechWindow
  return w.SpeechRecognition || w.webkitSpeechRecognition || null
}

export function resolveDefaultSpeechLocale(): SpeechLocale {
  const nav = typeof navigator !== 'undefined' ? navigator.language || '' : ''
  const lower = nav.toLowerCase()
  const hit = SPEECH_LOCALES.find(
    (l) => lower.startsWith(l.code) || lower.startsWith(l.stt.toLowerCase()),
  )
  return hit || SPEECH_LOCALES[0]
}
